import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_REQUIRED_MILES_STORE_NAME, GetRequiredMilesState } from './get-required-miles.state';

/** Select GetRequiredMiles State */
export const selectGetRequiredMilesState = createFeatureSelector<GetRequiredMilesState>(GET_REQUIRED_MILES_STORE_NAME);

/** Select GetRequiredMiles isPending status */
export const selectGetRequiredMilesIsPendingStatus = createSelector(
  selectGetRequiredMilesState,
  (state) => !!state.isPending
);

/** Select GetRequiredMiles isFailure status */
export const selectGetRequiredMilesIsFailureStatus = createSelector(
  selectGetRequiredMilesState,
  (state) => !!state.isFailure
);

/** Select GetRequiredMiles isFailure status */
export const selectGetRequiredMiles = createSelector(
  selectGetRequiredMilesState,
  (state) => state && state.model?.data
);
